import React from 'react'
import classNames from 'classnames'
import styles from './GovernancePdfs.module.scss'
import PdfCard from '../ui/PdfCard/PdfCard'

const GovernancePdfs = ({ data }) => {
  return (
    <div className={classNames(styles.container)}>
      <div className={classNames(styles.title)}>{data?.title}</div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-6 gap-y-8">
        {data?.pdfs?.map((card) => {
          return (
            <PdfCard
              key={'pdfcard' + card?.id}
              title={card?.title}
              link={card?.fileinfo?.url}
              fileName={card?.fileinfo?.name}
              isView={true}
              isDownload={false}
            />
          )
        })}
      </div>
    </div>
  )
}

export default GovernancePdfs
